import { GqlClient } from './gql';
import configEnv from 'config/config-env';

import MarketService from './market/MarketService';
import ConfigService from './config/ConfigService';

const gqlRequestClientCables = new GqlClient(configEnv.cablesGqlUrl);

export interface Services {
  gqlRequestClientCables: GqlClient;
  marketService: MarketService;
  configService: ConfigService;
}

const services = {
  gqlRequestClientCables,
  marketService: new MarketService(gqlRequestClientCables),
  configService: new ConfigService(gqlRequestClientCables),
};

export default services;
